/* global sendError */

/* Generates the HTML (using crel) for the navigation button on the therapist page.
 * Parameters:
 * - right bool; whether the margin-left should be added
 * - padding: padding of the button
 * - borderRadius: borderRadius of the button
 * - button_url: where should the button lead
 * - button_text: button text
 * - button-icon: name of the material-icons icon.
 * - onclickObj: JSON obj: {"func": "<name of function as string>",
 *   "parameters" : "<array containing the parameters of the function>"}
 */
function createPatientButton(right, padding, borderRadius, buttonURL, buttonText, buttonIcon, onclickObj) {
    let style = `padding:${padding}; border-radius: ${borderRadius};`;

    if (right) {
        style += "; margin-left: 1rem";
    }

    let html = "";
    if (onclickObj) {
        const onclickFunction = `${onclickObj.func}(${onclickObj.params})`;
        html = crel(
            "a",
            {
                class: "col-md-5 btn btn-raised btn-primary",
                style,
                href: buttonURL,
                onclick: onclickFunction
            },
            crel("h3", { class: "text-c fs-4" }, buttonText),
            crel("i", { class: "md-36 material-icons" }, buttonIcon)
        );
    } else {
        html = crel(
            "a",
            { class: "col-md-5 btn btn-raised btn-primary", style, href: buttonURL },
            crel("h3", { class: "text-c fs-4" }, buttonText),
            crel("i", { class: "md-36 material-icons" }, buttonIcon)
        );
    }

    return html;
}

/* Shows a demo swal message to the demo user */
function demoMessage(demoText) {
    Swal.fire({
        title: "Demo",
        text: demoText,
        icon: "success"
    });
}
window.demoMessage = demoMessage;

// var html = crel('a', {class : "col-md-5 btn btn-raised btn-primary",
// style : "padding:" + padding + "; border-radius: " + borderRadius + ";", href : patientViewURL},
// crel('h3', {class: "text-c"}, trans.forms["therapist-patient-menu-patient-overview"]),
// crel('i', {class : "md-36 material-icons"}, "face")
// )

/*
 * Generates a patient menu and displays it using swal.
 */
function createPatientMenu(id, name) {
    const title = `Menu ${name}`;
    const padding = "1rem";
    const borderRadius = "10px";

    const demo = window.isDemo ? "/demo" : "";
    const sendMessageURL = `${demo}/therapist/patients/${id}/send`;
    const startVideoURL = `${demo}/therapist/call/${id}`;
    const patientViewURL = `${demo}/therapist/patients/${id}`;
    const messageHistoryURL = `${demo}/therapist/patients/${id}/history`;

    let deletePatientLink = "";
    // can only remove patients from the patients tied to therapists, so not when viewing all patients
    const status = $("#all-patients").prop("checked");
    if ($("#all-patients").length && !status) {
        deletePatientLink = crel(
            "div",
            { class: "mt-3" },
            createPatientButton(
                false,
                padding,
                borderRadius,
                "#",
                trans.forms["therapist-patient-menu-delete-link"],
                "delete",
                { func: "removePatientLink", params: [id, `'${name}'`].toString() }
                // Had to put the name like this since in the onclick it wants an explicit
                // string with quotes. Without it, the quotes are removed.
            )
        );
    }

    const wrapper = crel(
        "div",
        { class: "container" },
        crel(
            "div",
            { class: "mt-3" },
            createPatientButton(
                false,
                padding,
                borderRadius,
                patientViewURL,
                trans.forms["therapist-patient-menu-patient-overview"],
                "face",
                "",
                id,
                name
            ),
            createPatientButton(
                true,
                padding,
                borderRadius,
                sendMessageURL,
                trans.forms["therapist-patient-menu-send-exercises"],
                "send",
                "",
                id,
                name
            )
        ),
        crel(
            "div",
            { class: "mt-3" },
            window.isDemo
                ? createPatientButton(
                      false,
                      padding,
                      borderRadius,
                      "#",
                      trans.forms["therapist-patient-menu-start-video"],
                      "video_call",
                      { func: "demoMessage", params: [`'${trans.demo["demo-patient-menu-start-video"]}'`].toString() }
                  )
                : createPatientButton(
                      false,
                      padding,
                      borderRadius,
                      startVideoURL,
                      trans.forms["therapist-patient-menu-start-video"],
                      "video_call",
                      "",
                      id,
                      name
                  ),
            createPatientButton(
                true,
                padding,
                borderRadius,
                messageHistoryURL,
                trans.forms["therapist-patient-menu-previous-exercises"],
                "history",
                "",
                id,
                name
            )
        ),
        deletePatientLink
    );

    Swal.fire({
        title,
        html: wrapper,
        confirmButtonText: trans.video_call["video_call_how_button"],
        cancelButtonText: trans.forms["therapist-patient-menu-close"],
        showCancelButton: true
    }).then(value => {
        if (value.isConfirmed) {
            Swal.fire({
                title: trans.video_call["video_call_how_button"],
                text: trans.video_call["video_call_how"],
                confirmButtonText: trans.forms["therapist-patient-menu-understand"]
            }).then(_ => {
                createPatientMenu(id, name);
            });
        }
    });
}
window.createPatientMenu = createPatientMenu;

/*
 * Closes the current sweetalert menu and calls another one which
 * asks the user whether they really want to unlink the patient
 */
function removePatientLink(id, name) {
    Swal.close();

    if (window.isDemo) {
        demoMessage(trans.demo["demo-patient-menu-delete-link-msg"]);
        return;
    }

    Swal.fire({
        icon: "warning",
        title: trans.forms["are_you_sure"],
        text: trans.forms["therapist-patient-menu-delete-link-msg"],
        confirmButtonText: trans.forms["therapist-patient-menu-delete-link-accept"],
        denyButtonText: trans.forms.cancel,
        focusDeny: true,
        showDenyButton: true
    }).then(value => {
        if (!value.isConfirmed) {
            createPatientMenu(id, name);
        } else {
            $.ajax({
                method: "post",
                url: "/therapist/delete_patient_therapist_link",
                headers: {
                    "X-CSRF-TOKEN": $("meta[name='csrf-token']").attr("content")
                },
                data: {
                    patient_id: id
                }
            })
                .done(_ => {
                    Swal.close();
                    window.location.reload();
                })
                .fail(data => {
                    sendError(data);
                });
        }
    });
}
window.removePatientLink = removePatientLink;
